<template>
  <section>
    <div class="content">
      <Title title="線上購物相關常見問題與解答" class="content-title" />
      <p>
        Q1.
        我可以取消整筆訂單、取消訂單內的某些商品、減少訂購數量、更改付款工具或者修改配送地址嗎?
      </p>
      <p>
        A1.
        訂單交易成立後20分鐘內，可透過希望聯盟消費合作社Line@生活圈通知客服人員取消整筆訂單；目前系統服務暫無法修改訂購數量，此功能需下階段系統升級才能提供此服務功能。
        取消整筆訂單請至「希望聯盟消費合作社Line@生活圈」註明原購買的商品以及說明並確認要取消的訂單，客服人員會按照您的確認說明手動取消原訂單，消費款項亦會通知原刷卡銀行返還至原信用卡帳戶。
      </p>
      <p>
        Q2. 我可以直接將商品拿去希望聯盟消費合作社退貨嗎？
      </p>
      <p>
        A2.
        直接至希望聯盟消費合作社退貨是最直接快速的退貨退款方法。
        請攜帶希望聯盟合作社社員卡、原付款信用卡、您欲退的商品及其保證書、贈品及所有配件與包裝至希望聯盟消費合作社「地址：台中市大里區永隆二街27號」社員部辦理。
      </p>
      <p>
        Q3. 我收到商品發現商品瑕疵(撞壞/破損/失溫)要如何處理呢？
      </p>
      <p>
        A3.
        當您收到商品，請依正常程序(開封前檢視附有合作社貼紙並進行開箱錄影)儘速檢查商品。
        若發現商品瑕疵之情形，請在收到貨24小時內儘速將商品外箱照片及開箱影片上傳希望聯盟消費合作社Line@生活圈，並聯絡希望聯盟消費合作社客服中心，電話04-24068870，或您可透過「希望聯盟消費合作社Line@生活圈」來訊由希望聯盟客服進一步為您處理。
      </p>
      <p>
        Q4. 我無法前往合作社退貨，還有其他方式嗎？
      </p>
      <p>
        A4.<br>
        一）線上申請退貨：<br>
        1）除部份特定商品無法辦理線上申請退貨外，請至「希望聯盟消費合作社Line@生活圈」說明「退貨商品」，確認辦理退貨的商品；提供退貨商品照片/開箱影片、退貨數量、退貨原因及取貨住址。物流廠商向您收取退貨商品（取件後物流人員會給您貨運收據，請保留至收到退款為止）<br>
        2）請先將欲退貨之商品以原送貨時的包裝尺寸進行包裝後再交給前來取貨的物流廠商。<br>
        3）希望聯盟合作社檢查與確認商品。<br>
        4）線上客服人員將在7個工作天內，直接將退款金額退回原信用卡帳戶或原匯款銀行帳戶，實際款項退回時間需視發卡銀行作業而定。<br>
        5）希望聯盟消費合作社線上購物完成退款後，系統會在希望聯盟消費合作社Line@生活圈上通知您。<br>
        二）線上客服中心辦理退貨：
        請聯絡希望聯盟消費合作社客服中心，電話04-24068870，或您可透過「希望聯盟消費合作社Line@生活圈」來訊由希望聯盟客服進一步為您處理。
        請來訊或來電提供：<br>
        1）希望聯盟消費合作社社員卡號<br>
        2）訂單編號<br>
        3）商品名稱/件數<br>
        4）退貨商品包裝箱數<br>
        5）取件資訊：姓名/電話/收件住址<br>
        6)  開箱錄影及照片<br>
        7）退貨原因<br>

        線上客服人員確認訂單、商品照片/影片、金額及付款方式。

        1）物流廠商向您收取退貨商品（取件後物流人員會給您貨運收據，請保留至收到退款為止)<br>
        2）請先將欲退貨之商品以原送貨時的包裝尺寸進行包裝後再交給前來取貨的物流廠商。<br>
        3）檢查與確認商品。<br>
        4）線上客服人員將在7個工作天內，直接將退款金額退回原信用卡帳戶或原匯款銀行帳戶內，實際款項退回時間需視發卡銀行作業而定。<br>

        希望聯盟線上購物完成退款後，系統會在「希望聯盟消費合作社Line@生活圈」通知您。
      </p>
      <p>
        Q5. 我的訂單有使用線上購物回潤金或介紹購物金結帳，若整筆訂單取消或整筆退貨，退款金額將如何計算?
      </p>
      <p>
        A5.
        若您取消整筆訂單或辦理整筆退貨，退款金額將以扣掉購物回潤金或介紹購物金之後的實際付款金額為準。 全部退貨金額舉例說明： 消費$10,000元使用線上購物的購物回潤金/消費購物金$600元，辦理訂單整筆取消或整筆退貨，實際退款金額將以扣除購物回潤金/消費購物金$9,400元為準。
      </p>
    </div>
  </section>
</template>
<script>
import Title from '@/components/Title'

export default {
  components: {
    Title
  }
}
</script>
<style scoped lang="scss">
.content {
  position: relative;
  width: 100%;
  background-color: #e9e9e9;
  padding: 20px 20px;
  margin-top: 48px;
  p {
    color: #4c4c4c;
    line-height: 32px;
  }
}
.content-title {
  position: absolute;
  left: 0;
  top: -28px;
  @include minWidth992 {
    top: -40px;
  }
}
</style>
